import React, { useEffect, useState } from "react";
import FormComponent from "./FormComponent";
import { Form } from "antd";
import {
  dataToFormDataConverter,
  Notification,
} from "../../../../config/Global";
import { CONSTANT } from "../../../../config/Constant";

const EditComponent: React.FC<any> = (props) => {
  const { visible, close, editData, getList } = props;
  const [form] = Form.useForm();

  const [fileList, setFileList] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const authToken = localStorage.getItem("token");

  var myHeaders = new Headers();
  myHeaders.append("Authorization", authToken ? authToken : "");

  const handleSubmit = async (data?: any) => {
    setLoading(true);
    data.id = editData?._id;
    delete data?.company_name;
    delete data?.icicid;
    const newObj = {};
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        newObj[key] = data[key] === undefined ? "" : data[key];
      }
    }
    const payload = {
      ...newObj,
    };
    const formData = dataToFormDataConverter(payload);

    if (fileList.length > 0) {
      formData.append("file", fileList[0]?.originFileObj);
    }
    try {
      const response = await fetch(
        `${CONSTANT.BASE_URL}/company_management/update`,
        {
          method: "POST",
          body: formData,
          headers: myHeaders,
        }
      );
      const responseData = await response.json();

      if (response.ok) {
        form.resetFields();
        getList();
        handleClose();
        setFileList([]);
        setLoading(false);
        Notification.success({
          message: "File uploaded successfully.",
        });
      } else {
        if (responseData.notification) {
          Notification.error({
            message: responseData.notification.join(", "), // Combine messages into a single string
          });
        }
      }
    } catch (error) {
      setLoading(false);
      console.error("Error uploading file:", error);
      Notification.error({
        message: "File upload failed.",
      });
    }
  };

  const handleClose = () => {
    close();
    form.resetFields();
  };

  useEffect(() => {
    if (visible && editData) {
      form.setFieldsValue({
        ...editData,
        file: null,
      });
      // if (editData?.file) {
      //   const fileName = editData?.file.split("/").pop();
      //   setFileList([
      //     {
      //       uid: "-1", // Unique identifier
      //       name: fileName, // File name
      //       status: "done", // Status of the file (e.g., 'done', 'uploading', 'error')
      //       url: editData?.file, // URL of the file
      //     },
      //   ]);
      // }
    }
  }, [editData, form, visible]);

  return (
    <>
      <FormComponent
        handleSubmit={handleSubmit}
        form={form}
        visible={visible}
        close={handleClose}
        title={"Edit Company Management"}
        loading={loading}
        setFileList={setFileList}
        fileList={fileList}
        type="Edit"
      />
    </>
  );
};

export default EditComponent;
